import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from 'semantic-ui-react';

import 'PointOfSale/styles/components/button.less';

const POSButton = props => {
  const {
    label,
    selected,
    clickHandler,
    disabled,
    variant,
    item,
    className,
    ...others
  } = props;
  const btnClass = classNames('pos-button', {
    selected: selected,
    flat: variant === 'flat',
    [className]: className,
  });

  return (
    <Button
      className={btnClass}
      selected={selected}
      onClick={() => clickHandler(item)}
      disabled={disabled}
      variant={variant}
      {...others}
    >
      <Button.Content>
        <span className="button-text">{label}</span>
        {props.children}
      </Button.Content>
    </Button>
  );
};

POSButton.propTypes = {
  label: PropTypes.string,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['flat', 'default']),
  clickHandler: PropTypes.func,
};

POSButton.defaultProps = {
  label: 'Button',
  selected: false,
  disabled: false,
  variant: 'default',
};

export default POSButton;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/Button.js